"use client";

import { type ComponentProps } from "react";
import { ResultList } from "./ResultList";
import { useItemListing } from "./ItemListingContext";

export function SearchResultList(props: ComponentProps<typeof ResultList>) {
  const { results, search, loadMore, isLastPage, isLoading } = useItemListing();

  return (
    <ResultList
      {...props}
      searchResults={results}
      batchSize={search.limit}
      pagination={{ loadMore, isLastPage, isLoading }}
    />
  );
}
